var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_133_3284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66668 8.66662C6.95295 9.04936 7.31822 9.36602 7.73768 9.59522C8.15715 9.82442 8.62102 9.96069 9.09775 9.99482C9.57455 10.029 10.0531 9.96016 10.5009 9.79309C10.9488 9.62609 11.3554 9.36462 11.6934 9.02662L13.6934 7.02662C14.3006 6.39792 14.6365 5.55592 14.6289 4.68193C14.6213 3.80794 14.2707 2.9719 13.6527 2.35387C13.0347 1.73584 12.1987 1.38528 11.3247 1.37769C10.4507 1.37009 9.60868 1.70608 8.98002 2.31327L7.83335 3.45327M9.33335 7.33329C9.04702 6.95049 8.68175 6.63381 8.26228 6.40464C7.84282 6.17547 7.37902 6.03919 6.90222 6.00504C6.42548 5.9709 5.94695 6.03969 5.49911 6.20674C5.05127 6.3738 4.6446 6.63522 4.30668 6.97329L2.30668 8.97329C1.69948 9.60196 1.3635 10.444 1.3711 11.318C1.37869 12.192 1.72925 13.028 2.34728 13.646C2.9653 14.264 3.80135 14.6146 4.67534 14.6222C5.54932 14.6298 6.39133 14.2938 7.02002 13.6866L8.16002 12.5466",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_133_3284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.23448fa1a4a3de606187b8d792384824.svg";
export { ForwardRef as ReactComponent };